import { axiosGet, axiosPost } from "../../../react_axios/Axios";
import { headers, EXH_STALL_POSSESSION_CHECKLIST_LIST, EXH_STALL_POSSESSION_CHECKLIST_DETAILS, EXH_UPDATE_STALL_POSSESSION_CHECKLIST, getExhStallPossessionListUrl, getExhStallPossessionChecklistDetailsUrl, updateExhStallPossessionChecklistUrl, VERIFY_STALL_POSSESSION_QR, verifyStallPossessionQRUrl, submitStallPossessionQRUrl, SUBMIT_STALL_POSSESSION_QR, tagDDSubmitUrl, TAG_DD_SUBMIT } from "../../../utils/constants";


export const getExhStallPossessionList_action = (ExhibitionID, CompanyName, ExhRegistrationNo, HallID, StallID, StatusID, PossessionStartDate, PossessionEndDate, ZoneID) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: ExhibitionID != '' ? ExhibitionID : null,
            CompanyName: CompanyName != '' ? CompanyName : null,
            ExhRegistrationNo: ExhRegistrationNo != '' ? ExhRegistrationNo : null,
            HallID: HallID != '' ? HallID : null,
            StallID: StallID != '' ? StallID : null,
            StatusID: StatusID,
            PossessionStartDate: PossessionStartDate,
            PossessionEndDate: PossessionEndDate,
            ZoneID: ZoneID,
        }

        const res = await axiosGet(getExhStallPossessionListUrl, params, headers)

        dispatch({
            type: EXH_STALL_POSSESSION_CHECKLIST_LIST,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getExhStallPossessionDetails_action = (ExhibitionID, ExhRegistrationID) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: ExhibitionID != '' ? ExhibitionID : null,
            ExhRegistrationID: ExhRegistrationID != '' ? ExhRegistrationID : null,
        }

        const res = await axiosGet(getExhStallPossessionChecklistDetailsUrl, params, headers)

        dispatch({
            type: EXH_STALL_POSSESSION_CHECKLIST_DETAILS,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const updateExhStallPossessionChecklist_action = (ExhibitionID, ExhRegistrationNo, ExhRegistrationID, ITMEStaffName, IssuedDate, Remark, ExhStallPossessionChecklist, ExitPersonName, ExitCompanyName, ExitMobileNo, ExitEmailID, ExhStallPossessionVendorDDdetails, ExhStallPossessionVendorSubcontractordetails, IsNDCMarked) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: ExhibitionID != '' ? ExhibitionID : sessionStorage.getItem('sessionExhibitionID'),
            ExhRegistrationNo: ExhRegistrationNo != '' ? ExhRegistrationNo : null,
            ExhRegistrationID: ExhRegistrationID != '' ? ExhRegistrationID : null,
            ITMEStaffName: ITMEStaffName,
            IssuedDate: IssuedDate,
            Remark: Remark,
            ExhStallPossessionChecklist: ExhStallPossessionChecklist,
            ExitPersonName: ExitPersonName,
            ExitCompanyName: ExitCompanyName,
            ExitMobileNo: ExitMobileNo,
            ExitEmailID: ExitEmailID,
            ExhStallPossessionVendorDDdetails: ExhStallPossessionVendorDDdetails,
            ExhStallPossessionVendorSubcontractordetails: ExhStallPossessionVendorSubcontractordetails,
            IsNDCMarked: IsNDCMarked,
        }

        const res = await axiosPost(updateExhStallPossessionChecklistUrl, params, headers)

        dispatch({
            type: EXH_UPDATE_STALL_POSSESSION_CHECKLIST,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const verifyStallPossessionQR_action = (HallnoStallno, ExhibitionID) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            HallnoStallno: HallnoStallno,
            ExhibitionID: ExhibitionID,
        }

        const res = await axiosPost(verifyStallPossessionQRUrl, params, headers)

        dispatch({
            type: VERIFY_STALL_POSSESSION_QR,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const submitStallPossessionQR_action = (Stallpossessiontakenby, ExhRegistrationList, PossessionTakenByMobileNo) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            Stallpossessiontakenby: Stallpossessiontakenby,
            ExhRegistrationList: ExhRegistrationList,
            PossessionTakenByMobileNo: PossessionTakenByMobileNo,
        }

        const res = await axiosPost(submitStallPossessionQRUrl, params, headers)

        dispatch({
            type: SUBMIT_STALL_POSSESSION_QR,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const tagDDSubmit_action = (ExhStallPossessionVendorDDdetailsID, IsDDSubmitted, isSendMail) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            ExhStallPossessionVendorDDdetailsID: ExhStallPossessionVendorDDdetailsID,
            IsDDSubmitted: IsDDSubmitted,
            IsSendMail: isSendMail,
        }

        const res = await axiosPost(tagDDSubmitUrl, params, headers)

        dispatch({
            type: TAG_DD_SUBMIT,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}